import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { environmentSelector } from '@selectors/commonSelectors';
import { useAppSelector } from '../../../../hooks';

/**
 * Wraps children with GoogleReCaptchaProvider when a valid site key is available.
 * When captcha is hidden by env config, children render without a provider.
 * When captcha is required but the site key is missing (misconfiguration),
 * logs an error and renders nothing to prevent unprotected form submissions.
 */
const WithRecaptcha = ({ children }: { children: React.ReactNode }) => {
    const environment = useAppSelector(environmentSelector);
    const hideCaptcha = environment?.hideCaptcha;
    const siteKey = environment?.properties?.RECAPTCHA_SITE_KEY;

    if (hideCaptcha) {
        return <>{children}</>;
    }

    if (!siteKey) {
        return null;
    }

    return (
        <GoogleReCaptchaProvider
            reCaptchaKey={siteKey}
            useEnterprise
            language={environment?.language}
            scriptProps={{ async: true, defer: true }}
        >
            {children}
        </GoogleReCaptchaProvider>
    );
};

export default WithRecaptcha;
